import fileDownload from "js-file-download";
import * as moment from "moment";
import {
    CONSULTAR_HISTORICOS_MENSAJES,
    CONSULTAR_HISTORICOS_RESPUESTAS,
    DESCARGAR_XLS_TABLA_HISTORICO_MSJ,
    TABLA_MENSAJES_CONSULTADOS,
    ERROR_CONSULTANDO_TABLA_RESPUESTA,
    EXITO_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS,
    ERROR_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS,
    tablaRespuestasConsultados,
    tablaMensajesConsultados,
    errorConsultandoTablaRespuesta,
    exitoDescargarTablaHistoricoMsjXLS,
    errorDescargarTablasHistoricoMsjXLS
} from "./consultaHistoricosActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroConsultaHistoricoMsj, FiltroConsultaHistoricoRta } from "../modelo/ReporteHistoricoModelo";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import { TipoConsulta } from "../modelo/TipoConsulta";
import { HistoricoMensaje } from "../modelo/ReporteHistoricoModelo";
import {
    cabeceraReporteHistoricoMensajes,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarHistoricosMensajeEpic = action$ =>
    action$.ofType(CONSULTAR_HISTORICOS_MENSAJES)
        .mergeMap((action: any) => {

            const url = `sat/consultar/historico-mensajes-sat?${obtenerFiltroConsultaMsj(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url,
                    {'tipoConsulta': TipoConsulta.CONSULTA_MENSAJE}
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return tablaMensajesConsultados(respuesta.datosMensajes, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoTablaRespuesta()];
                });
        });

export const consultarHistoricosRespuestaEpic = action$ =>
    action$.ofType(CONSULTAR_HISTORICOS_RESPUESTAS)
        .mergeMap((action: any) => {

            const url = `sat/consultar/historico-repuestas-sat?${obtenerFiltroConsultaRta(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url,
                    {'tipoConsulta': TipoConsulta.CONSULTA_RESPUESTA}
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return tablaRespuestasConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoTablaRespuesta()];
                });
        });

export const descargarXLSTablaHistoricoMsjEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_TABLA_HISTORICO_MSJ)
        .mergeMap((action: any) => {

            const url = `sat/consultar/historico-mensajes-sat?${obtenerFiltroConsultaMsj(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url,
                    {'tipoConsulta': TipoConsulta.CONSULTA_MENSAJE}
                )
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    if (respuesta && respuesta.datosMensajes) {
                        const excelBlob: Blob = construirXLS(respuesta.datosMensajes);
                        const nombreArchivo = `reporte_historico_mensaje_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                        fileDownload(
                            excelBlob,
                            nombreArchivo,
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        );
                        return exitoDescargarTablaHistoricoMsjXLS();
                    }
                    return errorDescargarTablasHistoricoMsjXLS();
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [];
                });
        });

export const consultaTablaHistoricosReducer = (state = {
    estado: REQUEST.NONE,
    estadoDescarga: REQUEST.NONE,
    datosRespuestaMsj: [],
    paginas: 0,
    totalDatosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_HISTORICOS_MENSAJES:
            return {
                ...state,
                estado: REQUEST.PENDING,
                datosRespuestaMsj: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalDatosConsulta: 0,
                paginaActual: action.filtro.paginaActual
            };
        case CONSULTAR_HISTORICOS_RESPUESTAS:
            return {
                ...state,
                estado: REQUEST.PENDING,
                datosRespuestaMsj: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalDatosConsulta: 0,
                paginaActual: action.filtro.paginaActual
            };
        case DESCARGAR_XLS_TABLA_HISTORICO_MSJ:
            return {
                ...state,
                estadoDescarga: REQUEST.PENDING
            };
        case EXITO_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS:
        case ERROR_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS:
            return {
                ...state,
                estadoDescarga: REQUEST.SUCCESS
            };
        case TABLA_MENSAJES_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                datosRespuestaMsj: action.datosRespuesta,
                paginas: action.paginas,
                totalDatosConsulta: action.totalDatos
            };
        case ERROR_CONSULTANDO_TABLA_RESPUESTA:
            return {
                ...state,
                estado: REQUEST.ERROR,
                datosRespuestaMsj: [],
                paginas: 0,
                totalDatosConsulta: 0
            };
        default:
            return state;
    }
};

const obtenerFiltroConsultaMsj = (filtro: FiltroConsultaHistoricoMsj) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.dniEmpleador) params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.fechaInicial) params.set('fechaInicio', filtro.fechaInicial);
        if (filtro.fechaFinal) params.set('fechaFin', filtro.fechaFinal);
        if (filtro.poliza) params.set('poliza', filtro.poliza);
        if (filtro.codigoSede) params.set('codigoSede', filtro.codigoSede);
        if (filtro.codigoCentroTrabajo) params.set('codigoCentroTrabajo', filtro.codigoCentroTrabajo);
        if (filtro.dniEmpleado) params.set('dniEmpleado', filtro.dniEmpleado);
        if (filtro.periodo) params.set('periodo', filtro.periodo);
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        if (filtro.listaServicios) filtro.listaServicios.forEach(codigo => params.append('codigoServicio', codigo.toString()));
        if (Number.isInteger(filtro.paginaActual)) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const obtenerFiltroConsultaRta = (filtro: FiltroConsultaHistoricoRta) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.consecutivoMensaje) params.set('consecutivo', filtro.consecutivoMensaje.toString());
        if (Number.isInteger(filtro.paginaActual)) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const construirXLS = (datos: Array<HistoricoMensaje>) => {
    /*Libros a generar en el XLS*/
    const libroDatos = 'Reporte Historico Mensajes';

    const librosXLS = [];
    librosXLS.push(libroDatos);

    const reporte = [];

    datos.forEach(dato => {
        reporte.push([
            { value: dato.consecutivoMensaje },
            { value: dato.consecutivoServicio },
            { value: dato.nombreServicio || ''},
            { value: dato.dniEmpleador || ''},
            { value: dato.poliza || ''},
            { value: dato.codigoSede || ''},
            { value: dato.codigoCentroTrabajo || ''},
            { value: dato.dniAfiliado || ''},
            { value: dato.periodo || ''},
            { value: dato.mensajeOriginal || ''},
            { value: dato.mensajeEnvioSAT || ''},
            { value: dato.mensajeRespuestaSAT || ''},
            { value: dato.fechaMensajeoriginal || ''},
            { value: dato.fechaMensajeEnvioSAT || ''},
            { value: dato.fechaMensajeRespuestaSAT || ''},
            { value: dato.error || ''},
            { value: dato.exitoso || ''},
            { value: dato.estado || ''},
            { value: dato.motivoRechazo || ''},
            { value: dato.fechaIngresa || ''},
            { value: dato.reprocesado || ''},
            { value: dato.observacion || ''},
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroDatos,
        cabecera: cabeceraReporteHistoricoMensajes(),
        datos: reporte,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_tabla_historicos/modulos/consultaHistoricosReducers.ts